// Dependencies
// -----------------------------------------------
import React from 'react';
import GoogleMapReact, { fitBounds } from 'google-map-react';

// Components
// -----------------------------------------------
import Spinner from '../resources/spinner';
import { SearchMapMarker } from './index';
import dedupeSearchMapResults from '../../../utils/dedupe-search-map-results';

// -----------------------------------------------
// COMPONENT->SEARCH-MAP -------------------------
// -----------------------------------------------
export default class SearchMapV2 extends React.Component {
  static propTypes = {};

  constructor(props) {
    super(props);
  }

  handleChange = val => {
    this.props.toggleSearchThisArea(true, val);
  };

  createMapOptions = maps => {
    return {
      gestureHandling: 'greedy',
      mapTypeControl: false,
      panControl: true,
      scrollwheel: true
    };
  };

  renderWithBounds() {
    const translate = this.props.translate;
    const results = dedupeSearchMapResults(this.props.filteredResults);
    const bounds = {
      ne: {
        lat: this.props.geoNELat,
        lng: this.props.geoNELon
      },
      sw: {
        lat: this.props.geoSWLat,
        lng: this.props.geoSWLon
      }
    };
    const size = {
      width: 640, // Map width in pixels
      height: 700 // Map height in pixels
    };
    const { center, zoom } = fitBounds(bounds, size);
    return (
      <GoogleMapReact
        center={center}
        zoom={this.props.zoom}
        options={this.createMapOptions}
        resetBoundsOnResize={false}
        onChange={this.handleChange}
      >
        {results.map(result => (
          <SearchMapMarker
            key={result.property.id}
            lat={result.location.geo_latitude}
            lng={result.location.geo_longitude}
            getStringifiedQueryString={this.props.getStringifiedQueryString}
            result={result}
            translate={translate}
          />
        ))}
      </GoogleMapReact>
    );
  }

  renderWithCenter() {
    const translate = this.props.translate;
    const results = dedupeSearchMapResults(this.props.filteredResults);
    const bounds = {
      ne: {
        lat: this.props.geoNELat,
        lng: this.props.geoNELon
      },
      sw: {
        lat: this.props.geoSWLat,
        lng: this.props.geoSWLon
      }
    };
    const size = {
      width: 640, // Map width in pixels
      height: 700 // Map height in pixels
    };
    const center = {
      lat: this.props.geoCenterLat,
      lng: this.props.geoCenterLon
    };
    return (
      <GoogleMapReact
        center={center}
        zoom={this.props.zoom}
        options={this.createMapOptions}
        resetBoundsOnResize={false}
        onChange={this.handleChange}
      >
        {results.map(result => (
          <SearchMapMarker
            key={result.property.id}
            lat={result.location.geo_latitude}
            lng={result.location.geo_longitude}
            getStringifiedQueryString={this.props.getStringifiedQueryString}
            result={result}
            translate={translate}
          />
        ))}
      </GoogleMapReact>
    );
  }

  render() {
    if (
      this.props.filteredResults &&
      this.props.geoNELat &&
      this.props.geoNELon &&
      this.props.geoSWLat &&
      this.props.geoSWLon
    ) {
      return this.renderWithBounds();
    } else if (
      this.props.filteredResults &&
      this.props.geoCenterLat &&
      this.props.geoCenterLon
    ) {
      return this.renderWithCenter();
    } else {
      return <Spinner />;
    }
  }
}
